import {createSelector} from 'reselect';

// Delivery Notes redux state
const deliveryNotesReducerSelector = state => state.deliveryNotes;

// Delivery Notes List
const deliveryNotesSelector = createSelector(
    deliveryNotesReducerSelector,
    deliveryNotesReducer => deliveryNotesReducer.get('payload')
);

// Delivery Notes is fetching
const deliveryNotesIsFetchingSelector = createSelector(
    deliveryNotesReducerSelector,
    deliveryNotesReducer => deliveryNotesReducer.get('isFetching')
);

// Delivery Notes error
const deliveryNotesErrorSelector = createSelector(
    deliveryNotesReducerSelector,
    deliveryNotesReducer => deliveryNotesReducer.get('error')
);

export {
    deliveryNotesSelector,
    deliveryNotesIsFetchingSelector,
    deliveryNotesErrorSelector
};